/** @jsx h */

import format from 'date-fns/format';
import { h, Component } from 'preact';
import { route } from 'preact-router';
import { connect } from 'preact-redux';
import { activityTypes, DATE_FORMAT, TIME_FORMAT } from '../../../utils/consts';
// eslint-disable-next-line import/no-cycle
import { routes } from '../../app';

import missedCallIcon from '../../../assets/icons/missedCall.png';
import message from '../../../assets/icons/message.png';
import newMessage from '../../../assets/icons/newMessage.png';
import errorTextIcon from '../../../assets/errorTextIcon.png';


import style from './style.scss';

import { selectApplicationActiveNowBadgeTime } from '../../../reducers/application';
// eslint-disable-next-line import/no-cycle
import { getFormattedLastVisit } from '../../../utils';


class Activity extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lastVisit: props.timeOffset && this.getLastVisit(props),
    };
  }

  componentDidMount() {
    this.setState({
      lastVisit: this.getLastVisit(this.props),
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.timeOffset !== this.props.timeOffset) {
      this.setState({
        lastVisit: this.getLastVisit(nextProps),
      });
    }
  }

  getLastVisit = (props) => {
    let lastVisit;
    if (props.activity.state.onCall) {
      lastVisit = 'On call';
    } else if (props.activity.state.activeNow) {
      lastVisit = '';
    } else {
      lastVisit = getFormattedLastVisit(props.activity.state.msDateLastActive, props.activeNowBadgeTime);
    }

    return lastVisit;
  };

  gotoHandler = (id) => () => {
    if (this.props.client) {
      firebase.analytics().logEvent('Tap_on_any_Pro_in_My_Clients');
      route(routes.USER_FOR_COMP + id);
    } else {
      firebase.analytics().logEvent('Tap_on_any_Pro_in_My_Pros');
      route(routes.USER_FOR_COMP + id);
    }
  };

  render({ activity = {}, pro, badges: { missedMessage = 0, missedCall = 0 } }, { lastVisit }) {
    const activityDate = new Date(activity.activityDate);
    const isMc = pro && missedMessage + missedCall > 0 && (activity.activity === 'callMissed' || activity.activity === 'callDeclined' || activity.activity === 'callWithdrawn' || activity.activity === 'callFailed' || activity.activity === 'callDisconnected');
    const isBold = isMc || activity.activity === 'uim';

    return (
      <div className={style.activity} onClick={this.gotoHandler(activity.id)}>
        <div className={style.contact}>
          <div className={style.avatar}>
            {(activity.avatarUrl) ? (
              <img src={activity.avatarUrl} alt={activity.nickname} />
            ) : (
              <img src="/assets/nouserimage.jpg" alt={activity.nickname} />
            )}
            {(lastVisit !== false) && (
              <div className={activity.state.onCall ? style.call : ''}>
                <span>{lastVisit}</span>
              </div>
            )}
          </div>
          <div className={style.info}>
            <h3>{activity.nickname}</h3>
            {!this.props.client && activity.pro !== null && (
              <div>
                {activity.pro.profession}
              </div>
            )}
          </div>
        </div>
        <div className={`${style.type} ${isBold ? style.typeBold : ''}`}>
          <img className={style.icon} src={activity.activity === 'chatError' ? errorTextIcon : isMc ? missedCallIcon : activity.activity === 'uim' ? newMessage : message} />
          <span>{ activityTypes[activity.activity] }</span>
          <span className={style.date}>
            {`${format(activityDate, DATE_FORMAT)} at ${format(activityDate, TIME_FORMAT)}`}
          </span>
          <div className={`${style.count} ${isBold ? style.countRed : ''}`}>{ isBold && missedCall + missedMessage}</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  activeNowBadgeTime: selectApplicationActiveNowBadgeTime(state),
});

export default connect(mapStateToProps)(Activity);



// WEBPACK FOOTER //
// ./components/profile/activity/index.js